import { render, staticRenderFns } from "./ServiceTypeChecklistItemEditor.vue?vue&type=template&id=58cfaed8&scoped=true"
import script from "./ServiceTypeChecklistItemEditor.vue?vue&type=script&lang=js"
export * from "./ServiceTypeChecklistItemEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cfaed8",
  null
  
)

export default component.exports